var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.4132,
    y: 3.71002,
    width: 23,
    height: 23,
    rx: 5,
    ry: 5,
    transform: "translate(-6.38713 15.00014) rotate(-45)",
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8877,10.96747l-3.84497-3.84497-.64502,2.18311,3.07593,3.07593c1.55957,1.55957,1.55957,4.09717,0,5.65674l-4.73145,4.73145c-1.51172,1.51172-4.146,1.51172-5.65771,0l-4.73145-4.73145c-.75537-.75586-1.17139-1.75977-1.17139-2.82812s.41602-2.07324,1.17139-2.82861l4.73145-4.73145c.38306-.38306.82605-.66949,1.29816-.86432l.47211-1.59778c.01776-.10046.07147-.33081.17834-.62238-1.23071.18134-2.41736.7251-3.36267,1.67041l-4.73145,4.73145c-1.1333,1.1333-1.75732,2.64014-1.75732,4.24268s.62402,3.10938,1.75732,4.24219l4.73145,4.73145c1.1333,1.13379,2.64014,1.75781,4.24268,1.75781s3.10938-.62402,4.24316-1.75781l4.73145-4.73145c2.33887-2.33887,2.33887-6.14551,0-8.48486Z",
    fill: "#82368c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.72818,3.6597c-1.1325-.31186-1.91881-.01896-2.3815.2773-.60987.3944-.9414.97564-1.12308,1.43512l-.0018-.00047-.0055.01863c-.11589.29757-.16893.53206-.18627.63038l-3.00358,10.16498.00346.00094-.00554.00133,1.34544,5.67031,4.21407-4.13644-.0058-.00592.00561.00156,3.01278-10.19719c.04806-.12084.11439-.32124.16808-.56888l.01407-.04769-.00387-.00106c.09812-.48419.1319-1.1354-.16305-1.77478-.2293-.49599-.7419-1.15294-1.8835-1.46812ZM17.83623,6.36814l-2.61412,8.89949-1.70064-.46869,2.6591-8.88727c.06734-.11731.14843-.22984.25739-.29863.17683-.11504.42705-.11613.75867-.02503.32057.0883.52125.21418.5973.37413.05407.114.05728.26263.04229.40601Z",
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.91b4246d3f1cc2d7b63c100e5843abca.svg";
export { ForwardRef as ReactComponent };